module.exports = __webpack_public_path__ + "media/images/application/template/menu-e06006c76849e463dda3c564efaabaac.svg";